import MenuFilters from './MenuFilters';

export default MenuFilters;
